import {connect} from 'react-redux';
import Locale from 'shared/components/Locale.jsx';
import {changeLanguage as onLocaleChange} from 'actions/creators/changeLanguage';

function select(state) {
    const languageId = state.application.get('languageId');

    return {
        languageId
    };
}

export default connect(select, {onLocaleChange})(Locale);



// WEBPACK FOOTER //
// ./js/sport-betting/components/header/Locale.jsx